import { useParams, useNavigate } from "react-router";
import { AdminAllNormasTeachingBundleScreenPath } from "./AdminAllNormasTeachingBundleScreen.tsx";
import { useUpdateNormasTeachingBundle } from "../../ProductService/NormasTeachingBundle/useUpdateNormasTeachingBundle.ts";
import {
  CreateNormasTeachingBundleForm,
  CreateNormasTeachingBundleFormValues,
} from "./CreateNormasTeachingBundleForm.tsx";
import { useNormasTeachingBundleById } from "../../ProductService/NormasTeachingBundle/useNormasTeachingBundleById.ts";
import { useAllNormasTeachingProducts } from "../../ProductService/NormasTeachingProduct/useAllNormasTeachingProducts.ts";
import { useKnownPurchaseAcTags } from "../../ProductService/useKnownPurchaseAcTags.ts";
import { useKnownRefundAcTags } from "../../ProductService/useKnownRefundAcTags.ts";
import { useKnownAnalyticsTags } from "../../ProductService/useKnownAnalyticsTags.ts";
import { FullPageLoading } from "../../UI/FullPageLoading.tsx";

export const EditNormasTeachingBundleScreenPath =
  "/admin/normasteaching/edit-bundle/:bundleId";

export function EditNormasTeachingBundleScreen() {
  const { bundleId } = useParams<{ bundleId: string }>();

  const { bundle, isLoading: loadingProduct } = useNormasTeachingBundleById(
    bundleId!,
  );

  const { products } = useAllNormasTeachingProducts();
  const { isLoading: isLoadingPurchaseTags, purchaseTags } =
    useKnownPurchaseAcTags("bundles");
  const { isLoading: isLoadingRefundTags, refundTags } =
    useKnownRefundAcTags("bundles");
  const { isLoading: isLoadingAnalyticsTags, analyticsTags } =
    useKnownAnalyticsTags("bundles");

  const navigate = useNavigate();

  const { updateNormasTeachingBundle, loading: updating } =
    useUpdateNormasTeachingBundle();

  const onSubmit = async (data: CreateNormasTeachingBundleFormValues) => {
    if (!bundleId) return;

    try {
      await updateNormasTeachingBundle(bundleId, {
        bundleName: data.bundleName,
        variantBundleName: data.variantBundleName,
        priceInCents: { amount: data.priceInEuros * 100, currency: "EUR" },
        purchaseAcTags: data.purchaseAcTags ?? [],
        refundAcTags: data.refundAcTags ?? [],
        bundleProducts: data.bundleProducts.map((bundle) => ({
          products: bundle.products.map((product) => ({
            id: product.id,
            priceInCents: {
              amount: product.priceInEuros * 100,
              currency: "EUR",
            },
          })),
        })),
        analyticsTag: data.analyticsTag,
        stripeConfig: data.stripeConfig,
        heylightConfig: data.heylightConfig,
        bundleDescription: data.bundleDescription,
        isCouponEnabled: data.isCouponEnabled,
      });
      window.location.href = AdminAllNormasTeachingBundleScreenPath;
    } catch (error) {
      console.error("Errore durante l'aggiornamento del prodotto:", error);
    }
  };

  if (
    loadingProduct ||
    isLoadingPurchaseTags ||
    isLoadingRefundTags ||
    isLoadingAnalyticsTags
  ) {
    return <FullPageLoading />;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <button
          onClick={() => navigate(AdminAllNormasTeachingBundleScreenPath)}
          className="text-blue-600 hover:text-blue-800 flex items-center gap-2"
        >
          ← Torna alla lista bundle
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold mb-6">Modifica Bundle</h1>

        <CreateNormasTeachingBundleForm
          initialKnownPurchaseAcTags={purchaseTags}
          initialKnownRefundAcTags={refundTags}
          initialKnownAnalyticsTags={analyticsTags}
          products={products}
          creating={updating}
          onSubmit={onSubmit}
          initialBundle={bundle}
          isEditMode={true}
        />
      </div>
    </div>
  );
}
